import React from 'react'
import styled from '@emotion/styled'
import { appHistory } from '@core/Utils/routing/history'
import { debounce } from '@mobi/utils/functions'
import { LoadingPlaceholder } from '@mobi/component-library/Common/LoadingPlaceholder'
import { AppRoutes } from '@core/AppRoutes'
import { NoticeBox } from '@core/Components/NoticeBox'
import type { BlackbookEntry } from '@core/Areas/Blackbook/types'
import { RunnerListWithData } from './Components/RunnerListWithData'
import { radius } from '@mobi/component-library/Theme/Common'
import { refetch } from '@core/Areas/AppHeader/Components/Wallet/Components/helpers/useGetSpecialTokens'

export const RunnerList: React.FC<{
  isLoading: boolean
  isError: boolean
  entries?: BlackbookEntry[] | null
}> = ({ isLoading, isError, entries }) => {
  if (isLoading) {
    return (
      <WrapperStyled data-testid='blackbook-loading'>
        <LoadingPlaceholder width='100%' height='4rem' borderRadius={radius.lg} />
      </WrapperStyled>
    )
  }

  if (isError || !entries) {
    return (
      <WrapperStyled data-testid='blackbook-data-error'>
        <NoticeBox
          hasBorder
          title='Oops, Unable to Get Data'
          subtitle='Please check your network connection.'
          buttonText='Try Again'
          buttonClick={debounce(() => refetch(), 1000)}
          noticeBoxType='Error'
        />
      </WrapperStyled>
    )
  }

  if (!entries || entries.length === 0) {
    return (
      <WrapperStyled data-testid='blackbook-empty'>
        <NoticeBox
          hasBorder
          title='Your Blackbook is Open!'
          subtitle='New to Blackbook? Go to an upcoming race to add your favourite runners to Blackbook and receive alerts when they’re next up.'
          noticeBoxType='Info'
          buttonText='Go to Next Races'
          buttonClick={() => appHistory.push(AppRoutes.NextEvents[0])}
        />
      </WrapperStyled>
    )
  }

  return (
    <WrapperStyled>
      <RunnerListWithData entries={entries} />
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  padding: '0.5rem',
})
